import React, { Component } from 'react';
import SeriesDashboardContainer from 'components/series/SeriesDashboardContainer';
import NavBar from 'components/navigation/NavBar';
import Constants from 'utils/Constants';


class NavigationContainer extends Component {
  constructor(props){
    super()
    this.state = {
      navBarOpen: false,
      navBarClass: 'container',
      selectedView: Constants.view.main
    }
    this.changeView = this.changeView.bind(this);
    this.toggleNavBar = this.toggleNavBar.bind(this);
    this.closeNavBar = this.closeNavBar.bind(this);
  }

  changeView(type){
    this.setState({
      selectedView: Constants.view[type]
    }, () => {
      if(this.state.navBarOpen) this.toggleNavBar();
    })
  }

  toggleNavBar(){
    if(this.state.navBarOpen) {
      this.setState({
        navBarOpen: false,
        navBarClass: 'closeContainer'
      })
    } else {
      this.setState({
        navBarOpen: true,
        navBarClass: 'openContainer'
      })
    }
    let event;
    if(typeof(Event) === 'function') {
      event = new Event('closeEdit');
    }else{
      event = document.createEvent('Event');
      event.initEvent('closeEdit', true, true);
    }
    window.dispatchEvent(event);
  }

  closeNavBar() {
    if(this.state.navBarOpen === true){
      this.setState({
        navBarOpen: false,
        navBarClass: 'closeContainer'
      })
    }
  }

  render() {
    return [
        <NavBar key="navbar"
          selectedView={this.state.selectedView}
          changeView={this.changeView}
          navBarOpen={this.state.navBarOpen}
          navBarClass={this.state.navBarClass}
          toggleNavBar={this.toggleNavBar}
          closeNavBar={this.closeNavBar} />,
        <SeriesDashboardContainer key="dashboard"
          closeNavBar={this.closeNavBar}
          toggleNavBar={this.toggleNavBar}
          navBarClass={this.state.navBarClass}
          navBarOpen={this.state.navBarOpen}
          changeView={this.changeView}
          selectedView={this.state.selectedView}
          navBarOpen={this.state.navBarOpen} /> ]
  }
}

export default NavigationContainer;



// WEBPACK FOOTER //
// ./src/scripts/components/navigation/NavigationContainer.js